exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".one-product-content>div[data-v-3c83da2c]{padding:8px 0 10px}", ""]);

// exports
